import { TIME_FORMAT } from "./Constants";

/**
 * Convierte la fecha y hora a la fecha y hora local
 * */
export const dateToDateLocale = (date:any) => {
    let d = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    return d;
}

/**
 * Transforma segundos al formato 00 h 00 m 00 s
 * @param seconds:number
 */
export const secondsToHMSWithoutParents = (seconds:number) => {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds - (h * 3600)) / 60);
    let s = (seconds - (h * 3600) - (m * 60)).toFixed();
    return h + "h " + (m < 10 ? "0" + m : m) + " m " + s + " s";
}

/**
 * Transforma segundos al formato 00 h 00 m 00 s
 * @param seconds:number
 */
export const secondsToHMSWithParents = (seconds:number) => {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds - (h * 3600)) / 60);
    let s = (seconds - (h * 3600) - (m * 60));
    let sF = s.toFixed();
    return "(" + h + "h " + (m < 10 ? "0" + m : m) + " m " + (s < 10 ? "0" + sF : sF) + " s)";
}

/**
 * Transforma segundos al formato seleccionado
 * @param seconds:number
 * @param withParents:boolean
 * @param complete:boolean
 * @param withUnits
 */
export const formatSeconds = (seconds:number, withParents:boolean, complete:boolean, withUnits:boolean) => {
    let format = localStorage.getItem(TIME_FORMAT);
    let result = "";
    let h;
    if (isNaN(seconds) || !isFinite(seconds)) return "--";

    switch (format) {
        case 'hrs':
            h = Math.floor(seconds / 3600);
            let m = Math.floor((seconds - (h * 3600)) / 60);
            let s = (seconds - (h * 3600) - (m * 60));
            let sF = s.toFixed();
            if (withUnits) {
                result = h + "h " + (m < 10 ? "0" + m : m) + "m" + (complete ? (s < 10 ? " 0" + sF : " " + sF) + "s" : "");
            } else {
                result = h + ":" + (m < 10 ? "0" + m : m) + (complete ? (s < 10 ? ":0" + sF : ":" + sF) : "");
            }
            break;
        case 'dec':
            h = seconds / 3600;
            result = h.toFixed(2) + (withUnits ? " h" : "");
            break;
    }

    return withParents ? "(" + result + ")" : result;
}

/**
 * Transforma segundos al formato 00:00:00
 * @param seconds:number
 */
export const secondsToHHMMSSWithoutParents = (seconds:number) => {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds - (h * 3600)) / 60);
    let s = (seconds - (h * 3600) - (m * 60));
    let sF = s.toFixed();
    return h + ":" + (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + sF : sF);
}

/**
 * Transforma segundos al formato 00:00:00
 * @param seconds:number
 */
export const secondsToHHMMSSWithParents = (seconds:number) => {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds - (h * 3600)) / 60);
    let s = (seconds - (h * 3600) - (m * 60));
    let sF = s.toFixed();
    return "(" + h + ":" + (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + sF : sF) + ")";
}

/**
 * Transforma segundos al formato HH:MM
 * @param seconds:number
 */
export const secondsToHHMM = (seconds:number) => {
    let h = Math.floor(seconds / 3600);
    let m = Math.floor((seconds - (h * 3600)) / 60);
    return h + ":" + (m < 10 ? "0" + m : m);
}

export const cutValueFormated = (value:string, index:number) => {
    return value.length > index ? value.substring(0,index-1) + "..." : value;
}

export const getNumberBusinessDaysOnward = (start:any, end:any) => {
  let sD_ = new Date(start);
  let eD_ = new Date(end);
  sD_.setHours(sD_.getHours() - 6, 0, 0,0);
  eD_.setHours(eD_.getHours() - 6, 0, 0, 0);
  if (sD_.getTime() === eD_.getTime()) {
      return 1;
  } else if (sD_.getTime() > eD_.getTime()) {
      return 0;
  } else {
    let c = 0;
    while (sD_.getTime() <= eD_.getTime()) {
      let day = new Date(sD_).getDay();
      if (day !== 0 && day !== 6) { c++; }
      sD_.setDate(sD_.getDate() + 1);
    }
    return c === 0 ? 1 : c;
  }
}

export const getNumberBusinessDaysBackward = (start:any, end:any) => {
  let sD_ = new Date(start);
  let eD_ = new Date(end);
  sD_.setHours(sD_.getHours() - 6, 0, 0, 0);
  eD_.setHours(eD_.getHours() - 6, 0, 0, 0);
  if (sD_.getTime() === eD_.getTime()) {
      return 1;
  } else if (sD_.getTime() < eD_.getTime()) {
      return 0;
  } else {
    let c = 0;
    while (sD_.getTime() >= eD_.getTime()) {
      let day = new Date(sD_).getDay();
      if (day !== 0 && day !== 6) { c++; }
      sD_.setDate(sD_.getDate() - 1);
    }
    return c === 0 ? 1 : c;
  }
}

// Determinar los estados permitidos a partir del estado actual
export const statusAllowedSinceStatus = ({status_id, status_name}:{status_id:number, status_name:string}): any[] => {
  let status:any = [];
  switch (status_id) {
    case 1:
      // CREADA
      status = [
        {idStatus: status_id, name: status_name},
        {idStatus: 2, name: "En Proceso"},
        {idStatus: 3, name: "Cancelada"}
      ];
      break;
    case 2:
      // EN PROCESO
      status = [
        {idStatus: status_id, name: status_name},
        {idStatus: 4, name: "Terminada"},
        {idStatus: 3, name: "Cancelada"}
      ];
      break;
    case 3:
      // CANCELADA
      status = [
        {idStatus: status_id, name: status_name},
        {idStatus: 2, name: "En Proceso"}
      ];
      break;
    case 4:
      // TERMINADA
      status = [
        {idStatus: status_id, name: status_name},
        {idStatus: 2, name: "En Proceso"}
      ];
      break;
  }

  return status;
}

export const getNameControlDays = (startDate:any, endDate:any) => {
  let count = Math.round(((endDate.getTime() - startDate.getTime()) / 86400000));
  let now = new Date();
  let countNow = Math.round(((now.getTime() - endDate.getTime()) / 86400000));
  if (countNow == 0) {
    switch(count) {
      case 0:
        return "dashboard.today";
      case 5:
        return "dashboard.last_5_days";
      case 15:
        return "dashboard.last_15_days";
      case 30:
        return "dashboard.last_30_days";
      default:
        return "dashboard.customized";
    }
  }

  return "dashboard.customized";
}

export const addNWorkingDaysToADate = (startDate:any, days:number, daysExcluded:any=[0,6]) => {
  let count = 1;
  //let sd = new Date(startDate);
  let dat = new Date(startDate);
  if (days == 0 || days == 1) {
    return startDate;
  } else {
    do {
      if (!daysExcluded.includes(dat.getDay())) {
        count++;    
      }
      dat.setDate(dat.getDate() + 1);
    } while (count <= days);
    dat.setDate(dat.getDate() - 1);
  }
  return dat;
}

export const countDays = (startDate:any, endDate:any, daysExcluded:any=[0,6]) => {
  //console.log(startDate);
  //console.log(endDate);
  let endDateInt = new Date(endDate);
  let count = 0;
  if (endDateInt < startDate) return 0;
  else if (endDateInt == startDate) return 1;
  else {
    while(endDateInt >= startDate) {
      if (!daysExcluded.includes(endDateInt.getDay())) {
        count++;    
      }
      endDateInt.setDate(endDateInt.getDate() - 1);
    }  
  }
  return count;
}